export default __webpack_public_path__ + "static/common-f623d18e7dae4a6e25e9dfe8b38cebab.webp";